import React from 'react'

import {  Grid } from 'semantic-ui-react';

import { withRouter} from 'react-router-dom'

import './style.css';

const EGG_SHOWING_CAP = 10;

class Egg extends React.Component {

render() {
    let count = this.props.count
    return (
      <React.Fragment >
      {count >= EGG_SHOWING_CAP && <Grid onClick={this.props.dismissFunction}>
        <Grid.Row columns={1}>
        <Grid.Column textAlign="center">
        <span role="img" aria-label="egg" textCenter="true" id="eggs">🐎</span>
        </Grid.Column>
        </Grid.Row> </Grid>}
      </React.Fragment>
    );
  }
}


export default withRouter(Egg);
